import React from "react"
import cx from "classnames"
import { PiRocketDuotone } from "react-icons/pi"
import "./SpaceRocket.scss"

/**
 * A small Chrome-dino style strip: pixel stars drift by and a rocket weaves around them.
 * Decorative only - for "waiting on something" states (unverified email, offline...).
 *
 * @param className {String} sizing/spacing overrides; colour comes from `color`
 * @param style {Object}
 */
const SpaceRocket = ({ className, style }) => (
    <div className={cx("x-space-rocket", className)} style={style} aria-hidden="true">
        {[0, 1, 2, 3].map((i) => (
            <div key={i} className={cx("x-space-rocket-star", "s" + i)} />
        ))}
        <div className="x-space-rocket-star far f0" />
        <div className="x-space-rocket-star far f1" />
        <PiRocketDuotone className="x-space-rocket-ship" />
    </div>
)

export default SpaceRocket
